module.exports = __webpack_public_path__ + "img/image2.4b4eaef6.png";